import React from "react";
import DocList from "../../_components/Purchasing/PurchaseDocList";
import { FiFileText, FiClock, FiCheckCircle, FiXCircle, FiUser, FiDollarSign, FiCreditCard, FiHome, FiSlash } from "react-icons/fi";
import { T, fmtMYR, fmtCurrency } from "../../_components/Purchasing/PurchaseShared";
import { getPurchaseOrders, getPurchaseOrderKpis, deletePurchaseOrder, getPurchaseOrderById } from "../../_services/purchase.service";
import { isPurchasingManager, isSuperAdmin, canAccessAccounting } from '../../utils/roleConstants';

export default function PurchaseOrders() {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    // BUM can only view — hide create button
    const viewOnly = isPurchasingManager(user) && !canAccessAccounting(user) && !isSuperAdmin(user);
    return (
        <DocList
            docType="Purchase Order"
            basePath="/purchases/purchase-orders"
            fetchList={getPurchaseOrders}
            bulkPrint={{ fetchById: getPurchaseOrderById }}
            fetchKpis={getPurchaseOrderKpis}
            deleteItem={deletePurchaseOrder}
            hideCreate={viewOnly}
            viewOnly={viewOnly}
            statuses={["All", "Draft", "Pending for Approval", "Approved", "Rejected", "Cancelled"]}
            kpiCards={[
                { label: "Total POs", key: "total", icon: FiFileText, color: T.accent },
                { label: "Pending", key: "pending", icon: FiClock, color: T.warning },
                { label: "Approved", key: "approved", icon: FiCheckCircle, color: T.success },
                { label: "Rejected", key: "rejected", icon: FiXCircle, color: T.danger },
                { label: "Cancelled", key: "cancelled", icon: FiSlash, color: T.textMuted },
            ]}
            previewFields={[
                { icon: FiClock, label: "Date", key: "date" },
                { icon: FiHome, label: "Supplier", key: "supplier" },
                { icon: FiUser, label: "Contact Person", key: "contactPerson" },
                { icon: FiDollarSign, label: "Grand Total", key: "grandTotal", render: (v, row) => fmtCurrency(v, row.currency) },
                { icon: FiCreditCard, label: "Payment Terms", key: "paymentTerms" },
            ]}
            searchOptions={[
                { key: "all", label: "All" },
                { key: "id", label: "PO No." },
                { key: "date", label: "Date" },
                { key: "contactPerson", label: "Contact Person" },
                { key: "supplier", label: "Company Name" },
            ]}
        />
    );
}
